import api from '../../../api';
import { UpdateOOOSettingsPayload } from '../types/out-of-office';

export const updateOOOSettings = async (payload: UpdateOOOSettingsPayload) =>
  api.patch(`/user/ooo-setting`, payload);
